import { Controller } from "@hotwired/stimulus"

// Saisie d'une ligne d'émission. Quand le poste change :
//  - préremplit l'unité physique par défaut du poste,
//  - restreint la liste des facteurs à ceux du poste choisi (plus lisible que
//    d'afficher les centaines de facteurs de tous les postes).
// Le facteur reste un select cherchable (select2), reconstruit à la volée.
export default class extends Controller {
  static values = { unites: Object, facteurs: Object }
  static targets = ["poste", "unite", "facteur"]

  posteChanged() {
    if (this.hasUniteTarget && this.hasPosteTarget) {
      const unite = this.unitesValue[this.posteTarget.value]
      if (unite) this.uniteTarget.value = unite
    }
    this.filtrerFacteurs()
  }

  filtrerFacteurs() {
    if (!this.hasFacteurTarget || !this.hasPosteTarget) return

    const sel = this.facteurTarget
    const liste = this.facteursValue[this.posteTarget.value] || []
    const $ = window.jQuery
    const estSelect2 = $ && $(sel).data("select2")

    if (estSelect2) $(sel).select2("destroy")

    sel.innerHTML = ""
    const vide = document.createElement("option")
    vide.value = ""
    vide.textContent = liste.length ? "Choisir un facteur" : "Choisissez d'abord un poste"
    sel.appendChild(vide)

    liste.forEach((f) => {
      const opt = document.createElement("option")
      opt.value = f.id
      opt.textContent = f.label
      if (f.monetaire) opt.dataset.monetaire = "1"
      sel.appendChild(opt)
    })

    if (estSelect2) $(sel).select2()
  }
}
